import {
  $createMentionNode,
  MentionData,
  MentionNode,
} from '../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/Nodes/MentionNode/MentionNode'
import { LEXICAL_NODES } from '../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/nodes'
import { createHeadlessEditor } from '@lexical/headless'
import { $createTextNode, $getRoot, $insertNodes, LexicalEditor, LexicalNode } from 'lexical'

export const INPUT_WITH_TOKEN_NODES = [MentionNode, ...LEXICAL_NODES]

export type InputWithTokensElements = {
  type: 'text' | 'mention' | 'line-break'
  content: string
  mentionData?: MentionData
}

export const getEditorStateFromElements = (elements?: InputWithTokensElements[]) => {
  if (!elements) {
    return null
  }
  const editor = createHeadlessEditor({ nodes: INPUT_WITH_TOKEN_NODES })

  editor.update(
    () => {
      const lexicalNodes = elements.map((element) => getLexicalNodesForInputWithTokensElements(editor, element)).flat()
      $getRoot().select()
      $insertNodes(lexicalNodes)
    },
    { discrete: true },
  )

  return editor.getEditorState()
}

const getLexicalNodesForInputWithTokensElements = (editor: LexicalEditor, element: InputWithTokensElements): LexicalNode[] => {
  const { type } = element
  switch (type) {
    case 'text':
    case 'line-break':
      return [$createTextNode(element.content)]
    case 'mention':
      if (!element.mentionData) {
        return []
      }
      return [$createMentionNode(element.mentionData.id, element.mentionData.label, element.mentionData.metadata)]
  }
}
